import { FC,useState } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Grid } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import passport from "../../assets/images/icons/passport.svg";
import idcard from "../../assets/images/icons/idcard.svg";
import license from "../../assets/images/icons/license.svg";
import licensecard from "../../assets/images/licensecard.svg";
import { Formik, Form } from "formik";
import { Button } from "@material-ui/core";
import ReactFlagsSelect from "react-flags-select";

import {VerificationDetailStyles} from "../Styles/IdentityVerificationStyles";


const INITIAL_FORM_STATE = {
  flagselect: "",
};

const VerificationDetails:FC = () => {
  const classes = VerificationDetailStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const [selected, setSelected] = useState<any>("");

  const radio = () => {};

  return (
    <Box className={classes.root} mt={isActive ? 3 : 5}>
      <Formik
        initialValues={{
          ...INITIAL_FORM_STATE,
        }}
        onSubmit={(values) => {
          console.log(values);
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <Grid className="mb-12" container spacing={isActive ? 2 : 3}>
              <Grid item md={12} xs={12}>
                <Typography variant="h3" color="secondary">
                  Issuing Country
                </Typography>
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  className="fw-normal"
                >
                  Country*
                </Typography>
                <ReactFlagsSelect
                  className="menu-flags"
                  selected={selected}
                  onSelect={(code:any) => setSelected(code)}
                />
              </Grid>
            </Grid>
            <Grid className="mb-12">
              <Box mb={1.5}>
                <Typography variant="h3" color="secondary">
                  Select ID Type
                </Typography>
              </Box>
              <Typography
                className="text-darkslate "
                variant="body1"
                component="span"
                color="secondary"
              >
                Use a valid government-issued photo ID. A residence permit is
                also a valid identity card.
              </Typography>
            </Grid>
            <Grid className="mb-12 mt-12" container spacing={isActive ? 2 : 3}>
              <Grid item md={2} sm={4} xs={12}>
                <Box className="radiowrapper">
                  <img src={passport} className="img-fluid" alt="passport" />
                  <input type="radio" name="radioselect" />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    Passport
                  </Typography>
                </Box>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <Box className="radiowrapper active">
                  <img src={license} className="img-fluid" alt="passport" />
                  <input
                    type="radio"
                    name="radioselect"
                    onChange={radio}
                    checked
                  />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    Driver License
                  </Typography>
                </Box>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <Box className="radiowrapper">
                  <img src={idcard} className="img-fluid" alt="passport" />
                  <input type="radio" name="radioselect" />
                  <Typography
                    variant="body1"
                    color="secondary"
                    className="text-grey fw-bold"
                  >
                    ID Card
                  </Typography>
                </Box>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <Box mt={2}>
                  <img src={licensecard} className="img-fluid dropshadow licensemobile" alt="license" />
                </Box>
              </Grid>
            </Grid>
            <Box
              display="flex"
              alignItems="center"
              justifyContent={isActiveXS ? "space-between" : ""}
              mt={isActiveXS ? 2 : 5}
            >
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                Next
              </Button>
              <Button
                className="socialbtn"
                variant="outlined"
                color="secondary"
                size="large"
              >
                Back
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default VerificationDetails;
